import { useCallback, useMemo } from 'react';
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import S from '../existing-modal.module.scss';
import { ExistingEmployeeItem } from './existing-employee-item';
import { setExistingFields, useExistingCtx } from '../../modal-existing-context';
import { useBusiness, useUser } from '../../../../../graphql/graph-hooks';
import classNames from 'classnames';
import { getRoleOptions } from '../../../../../helpers/employee-services';

const ExistingClubItem = ({ id: clubId, name, employments, businessTier }) => {
  const { t } = useTranslation();
  const {
    state: { selectedClubId },
    dispatch,
  } = useExistingCtx();
  const { roles, admin } = useUser();
  const { id: businessId } = useBusiness();
  const handleClubSelection = useCallback(() => {
    if (clubId !== selectedClubId)
      dispatch(
        setExistingFields({
          selectedClubId: clubId,
          form: {},
        })
      );
  }, [clubId, dispatch, selectedClubId]);

  const IS_SELECTED = useMemo(() => selectedClubId === clubId, [clubId, selectedClubId]);
  const USER_SLUG = admin ? 'ADMIN' : roles?.[businessId]?.slug ?? t('common.unknown');

  const OPTIONS = useMemo(() => {
    let role_options = getRoleOptions(businessTier);
    if (USER_SLUG === 'ADMIN') return role_options;
    const INDEX = role_options.findIndex(({ value }) => value === USER_SLUG);
    return role_options.slice(0, INDEX);
  }, [USER_SLUG, businessTier]);

  return (
    <li className={S.clubArea}>
      <div className={classNames(S.titleArea, { [S.selected]: IS_SELECTED })} onClick={handleClubSelection}>
        {`${name} (${employments.length})`}
      </div>

      {IS_SELECTED && (
        <ul className={S.employeeArea}>
          {IS_SELECTED && employments.length === 0 ? (
            <p className={S.emptyList}>{t('modals.existing_employee.no_employees')}</p>
          ) : (
            employments.map(({ employee }) => (
              <ExistingEmployeeItem key={`employee_${clubId}_${employee.id}`} options={OPTIONS} {...employee} />
            ))
          )}
        </ul>
      )}
    </li>
  );
};

ExistingClubItem.displayName = 'ExistingClubItem';
ExistingClubItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  employments: PropTypes.arrayOf(PropTypes.object),
  businessTier: PropTypes.string.isRequired
};

export { ExistingClubItem };
